export default __webpack_public_path__ + "static/media/details.7ce638e4.svg";